/**
 * Frequently Bought Together - digibazar.pk
 * Main product locked + 5% off per item + Popup search with multi-brand suggestions
 * Free delivery threshold: Rs. 5,000
 */

document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('[data-fbt-tiered]');
  if (!wrapper) return;

  const productId = wrapper.dataset.productId;
  const currentProductType = (wrapper.dataset.productType || '').trim().toLowerCase();
  const cardsTrack = wrapper.querySelector('[data-fbt-cards-track]');
  const prevBtn = wrapper.querySelector('[data-fbt-prev]');
  const nextBtn = wrapper.querySelector('[data-fbt-next]');
  const finalTotalEl = wrapper.querySelector('[data-fbt-final-total]');
  const shippingTagEl = wrapper.querySelector('[data-fbt-shipping-tag]');
  const addBundleBtn = wrapper.querySelector('[data-fbt-add-bundle]');
  const ctaTextEl = wrapper.querySelector('[data-fbt-cta-text]');
  const ctaSpinnerEl = wrapper.querySelector('.fbt-cta-spinner');
  const errorEl = wrapper.querySelector('[data-fbt-error]');
  const quickviewModal = wrapper.querySelector('[data-fbt-quickview-modal]');
  const quickviewBody = wrapper.querySelector('[data-fbt-quickview-body]');
  const quickviewCloseBtn = wrapper.querySelector('[data-fbt-quickview-close]');

  // Search popup
  const searchOpenBtn = wrapper.querySelector('[data-fbt-search-open]');
  const searchModal = wrapper.querySelector('[data-fbt-search-modal]');
  const searchCloseBtn = wrapper.querySelector('[data-fbt-search-close]');
  const searchInput = wrapper.querySelector('[data-fbt-search-input]');
  const searchResults = wrapper.querySelector('[data-fbt-search-results]');

  const FREE_SHIPPING_THRESHOLD = 500000; // Rs. 5,000 in cents
  const MAX_RELATED_PRODUCTS = 10;
  const FBT_DISCOUNT_CODE = 'FBT5';
  const FBT_DISCOUNT_PERCENT = 5;

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
    const amount = cents / 100;
    if (amount % 1 === 0) {
      return 'Rs. ' + amount.toLocaleString('en-US');
    }
    return 'Rs. ' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function escapeHtml(str) {
    return (str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // 2. Carousel arrows
  function updateCarouselArrows() {
    if (!cardsTrack || !prevBtn || !nextBtn) return;
    const scrollLeft = cardsTrack.scrollLeft;
    const maxScroll = cardsTrack.scrollWidth - cardsTrack.clientWidth;
    prevBtn.disabled = scrollLeft <= 10;
    nextBtn.disabled = scrollLeft >= maxScroll - 10;
  }

  if (prevBtn && nextBtn && cardsTrack) {
    prevBtn.addEventListener('click', function () {
      const card = cardsTrack.querySelector('.fbt-card');
      const cardWidth = card ? card.offsetWidth + 40 : 280;
      cardsTrack.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      const card = cardsTrack.querySelector('.fbt-card');
      const cardWidth = card ? card.offsetWidth + 40 : 280;
      cardsTrack.scrollBy({ left: cardWidth, behavior: 'smooth' });
    });

    cardsTrack.addEventListener('scroll', updateCarouselArrows);
  }

  // ═══════════════════════════════════════════════════════════════════
  // 3. Bundle state — 5% off per selected item
  // ═══════════════════════════════════════════════════════════════════
  function updateBundleState() {
    const selectedCards = wrapper.querySelectorAll('.fbt-card.is-selected');
    const otherSelected = wrapper.querySelectorAll('.fbt-card.is-selected:not(.fbt-card--locked)');

    let totalItemsCount = 0;
    let subtotal = 0;

    selectedCards.forEach(function (card) {
      const qty = parseInt(card.dataset.quantity || 1, 10);
      const price = parseFloat(card.dataset.price || 0);
      totalItemsCount += qty;
      subtotal += price * qty;
    });

    const discountActive = otherSelected.length > 0;
    const discountAmount = discountActive
      ? Math.round(subtotal * (FBT_DISCOUNT_PERCENT / 100))
      : 0;
    const finalTotal = subtotal - discountAmount;

    const isFreeShipping = finalTotal >= FREE_SHIPPING_THRESHOLD;

    if (finalTotalEl) {
      finalTotalEl.textContent = formatMoney(finalTotal);
    }

    const savingsEl = wrapper.querySelector('[data-fbt-savings]');
    const savingsAmountEl = wrapper.querySelector('[data-fbt-savings-amount]');

    if (savingsEl) {
      if (discountAmount > 0) {
        savingsEl.hidden = false;
        if (savingsAmountEl) {
          savingsAmountEl.textContent = '-Rs. ' + (discountAmount / 100).toLocaleString('en-US');
        }
      } else {
        savingsEl.hidden = true;
      }
    }

    if (shippingTagEl) {
      if (isFreeShipping) {
        shippingTagEl.innerHTML = '<span class="fbt-tag-free">🎉 Free Delivery (Saved Rs. 260)</span>';
      } else {
        shippingTagEl.innerHTML = '<span class="fbt-tag-fee">+ Rs. 260 Delivery</span>';
      }
    }

    if (addBundleBtn && ctaTextEl) {
      if (totalItemsCount === 0) {
        addBundleBtn.disabled = true;
        ctaTextEl.textContent = 'Select items to add';
      } else {
        addBundleBtn.disabled = false;
        if (discountActive) {
          ctaTextEl.textContent = 'Add to Cart - ' + formatMoney(finalTotal) + ' (5% OFF)';
        } else {
          ctaTextEl.textContent = 'Add to Cart - ' + formatMoney(finalTotal);
        }
      }
    }
  }

  // 4. Card listeners
  function attachCardListeners(card) {
    const checkbox = card.querySelector('.fbt-card__checkbox');

    if (card.classList.contains('fbt-card--locked')) {
      if (checkbox) {
        checkbox.checked = true;
        checkbox.disabled = true;
        checkbox.addEventListener('change', function (e) {
          e.preventDefault();
          checkbox.checked = true;
          card.classList.add('is-selected');
        });
      }
      card.classList.add('is-selected');
    } else if (checkbox) {
      checkbox.addEventListener('change', function () {
        card.classList.toggle('is-selected', checkbox.checked);
        updateBundleState();
      });
    }

    const select = card.querySelector('.fbt-card__select');
    if (select) {
      select.addEventListener('change', function (e) {
        e.stopPropagation();
        const selectedOption = select.options[select.selectedIndex];
        const newPrice = parseFloat(selectedOption.dataset.price);
        const newCompare = parseFloat(selectedOption.dataset.compareAt || newPrice);
        const newVariantId = selectedOption.value;

        card.dataset.price = newPrice;
        card.dataset.compareAt = newCompare;
        card.dataset.variantId = newVariantId;

        const salePriceEl = card.querySelector('.fbt-card__sale-price');
        if (salePriceEl) salePriceEl.textContent = formatMoney(newPrice);

        const compareEl = card.querySelector('.fbt-card__compare-price');
        if (compareEl) {
          if (newCompare > newPrice) {
            compareEl.textContent = formatMoney(newCompare);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        const saveTag = card.querySelector('.fbt-card__save-tag');
        if (saveTag) {
          if (newCompare > newPrice) {
            saveTag.innerHTML = '<svg viewBox="0 0 24 24" width="10" height="10" fill="currentColor"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg> Save ' + formatMoney(newCompare - newPrice);
            saveTag.hidden = false;
          } else {
            saveTag.hidden = true;
          }
        }

        updateBundleState();
      });
    }
  }

  const mainCard = wrapper.querySelector('.fbt-card--main');
  if (mainCard) {
    attachCardListeners(mainCard);
  }

  // 4b. Quick View Modal
  function openQuickviewModal() {
    if (!quickviewModal) return;
    if (typeof quickviewModal.showModal === 'function') {
      quickviewModal.showModal();
    } else {
      quickviewModal.setAttribute('open', '');
    }
  }

  function closeQuickviewModal() {
    if (!quickviewModal) return;
    if (typeof quickviewModal.close === 'function') {
      quickviewModal.close();
    } else {
      quickviewModal.removeAttribute('open');
    }
  }

  if (quickviewCloseBtn) {
    quickviewCloseBtn.addEventListener('click', closeQuickviewModal);
  }

  if (quickviewModal) {
    quickviewModal.addEventListener('click', function (e) {
      if (e.target === quickviewModal) {
        closeQuickviewModal();
      }
    });
  }

  function renderQuickviewLoading() {
    if (!quickviewBody) return;
    quickviewBody.innerHTML = '<div class="fbt-quickview-loading">Loading…</div>';
  }

  function renderQuickviewError() {
    if (!quickviewBody) return;
    quickviewBody.innerHTML = '<div class="fbt-quickview-loading">Could not load product details.</div>';
  }

  function renderQuickviewProduct(p, card) {
    if (!quickviewBody) return;

    const availableVariants = (p.variants || []).filter(function (v) { return v.available; });
    const initialVariant = availableVariants[0] || p.variants[0];

    const imageUrl = (p.images && p.images[0] && (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src)) || p.featured_image || '';
    const price = typeof initialVariant.price === 'string' ? Math.round(parseFloat(initialVariant.price) * 100) : initialVariant.price;
    const compareAt = initialVariant.compare_at_price
      ? (typeof initialVariant.compare_at_price === 'string' ? Math.round(parseFloat(initialVariant.compare_at_price) * 100) : initialVariant.compare_at_price)
      : price;

    let variantSelectHTML = '';
    if (availableVariants.length > 1) {
      let options = '';
      availableVariants.forEach(function (v) {
        const vPrice = typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price;
        const vCompare = v.compare_at_price
          ? (typeof v.compare_at_price === 'string' ? Math.round(parseFloat(v.compare_at_price) * 100) : v.compare_at_price)
          : vPrice;
        const isSel = v.id === initialVariant.id ? 'selected' : '';
        options += '<option value="' + v.id + '" data-price="' + vPrice + '" data-compare-at="' + vCompare + '" ' + isSel + '>' + escapeHtml(v.title) + '</option>';
      });
      variantSelectHTML = '<div class="fbt-quickview-select-pill"><select data-fbt-quickview-variant-select aria-label="Select variant">' + options + '</select></div>';
    }

    const descriptionText = (p.description || p.body_html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    const shortDesc = descriptionText.length > 260 ? descriptionText.slice(0, 260) + '…' : descriptionText;

    quickviewBody.innerHTML =
      '<div class="fbt-quickview-grid">' +
        '<div class="fbt-quickview-image"><img src="' + imageUrl + '" alt="' + escapeHtml(p.title) + '"></div>' +
        '<div class="fbt-quickview-info">' +
          '<h3 class="fbt-quickview-title">' + escapeHtml(p.title) + '</h3>' +
          '<div class="fbt-quickview-pricing" data-fbt-quickview-pricing>' +
            (compareAt > price ? '<span class="fbt-quickview-compare-price" data-fbt-quickview-compare>' + formatMoney(compareAt) + '</span>' : '') +
            '<span class="fbt-quickview-sale-price" data-fbt-quickview-sale>' + formatMoney(price) + '</span>' +
          '</div>' +
          (shortDesc ? '<p class="fbt-quickview-desc">' + escapeHtml(shortDesc) + '</p>' : '') +
          variantSelectHTML +
          '<button type="button" class="fbt-quickview-select-btn" data-fbt-quickview-select-btn>' +
            (card.classList.contains('is-selected') ? 'Selected in Bundle ✓' : 'Add to Bundle') +
          '</button>' +
        '</div>' +
      '</div>';

    const select = quickviewBody.querySelector('[data-fbt-quickview-variant-select]');
    const salePriceEl = quickviewBody.querySelector('[data-fbt-quickview-sale]');
    const comparePriceEl = quickviewBody.querySelector('[data-fbt-quickview-compare]');

    if (select) {
      select.addEventListener('change', function () {
        const opt = select.options[select.selectedIndex];
        const newPrice = parseFloat(opt.dataset.price);
        const newCompare = parseFloat(opt.dataset.compareAt || newPrice);

        card.dataset.price = newPrice;
        card.dataset.compareAt = newCompare;
        card.dataset.variantId = opt.value;

        const cardSalePriceEl = card.querySelector('.fbt-card__sale-price');
        if (cardSalePriceEl) cardSalePriceEl.textContent = formatMoney(newPrice);

        const cardSelect = card.querySelector('.fbt-card__select, .fbt-main-select');
        if (cardSelect) cardSelect.value = opt.value;

        if (salePriceEl) salePriceEl.textContent = formatMoney(newPrice);
        if (comparePriceEl) {
          if (newCompare > newPrice) {
            comparePriceEl.textContent = formatMoney(newCompare);
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.hidden = true;
          }
        }

        updateBundleState();
      });
    }

    const selectBtn = quickviewBody.querySelector('[data-fbt-quickview-select-btn]');
    if (selectBtn) {
      selectBtn.addEventListener('click', function () {
        const checkbox = card.querySelector('.fbt-card__checkbox');
        if (checkbox && !checkbox.disabled) {
          checkbox.checked = true;
          card.classList.add('is-selected');
          updateBundleState();
        }
        selectBtn.textContent = 'Selected in Bundle ✓';
        closeQuickviewModal();
      });
    }
  }

  let quickviewRequestToken = 0;

  wrapper.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-fbt-quickview]');
    if (!trigger) return;

    const card = trigger.closest('.fbt-card');
    if (!card) return;

    const handle = card.dataset.productHandle;
    if (!handle) return;

    quickviewRequestToken += 1;
    const thisToken = quickviewRequestToken;

    openQuickviewModal();
    renderQuickviewLoading();

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product fetch failed');
        return res.json();
      })
      .then(function (p) {
        if (thisToken !== quickviewRequestToken) return;
        renderQuickviewProduct(p, card);
      })
      .catch(function (err) {
        if (thisToken !== quickviewRequestToken) return;
        console.error('FBT quickview fetch error:', err);
        renderQuickviewError();
      });
  });

  // 5. Build dynamic card HTML
  function buildCardHTML(p, variant) {
    const availableVariants = (p.variants || []).filter(function (v) { return v.available; });
    const productUrl = '/products/' + encodeURIComponent(p.handle);
    const imageUrl = p.featured_image || (p.images && p.images[0]) || '';
    const price = variant.price;
    const compareAt = variant.compare_at_price || price;
    const savedAmount = compareAt > price ? compareAt - price : 0;

    let variantSelectHTML = '';
    if (availableVariants.length > 1) {
      let options = '';
      availableVariants.forEach(function (v) {
        const isSel = v.id === variant.id ? 'selected' : '';
        options += '<option value="' + v.id + '" data-price="' + v.price + '" data-compare-at="' + (v.compare_at_price || v.price) + '" ' + isSel + '>' + escapeHtml(v.title) + '</option>';
      });
      variantSelectHTML = '<div class="fbt-card__select-pill"><select class="fbt-card__select" aria-label="Select size">' + options + '</select></div>';
    }

    let compareHTML = '';
    if (compareAt > price) {
      compareHTML = '<span class="fbt-card__compare-price">' + formatMoney(compareAt) + '</span>';
    }

    let saveTagHTML = '';
    if (savedAmount > 0) {
      saveTagHTML = '<span class="fbt-card__save-tag"><svg viewBox="0 0 24 24" width="10" height="10" fill="currentColor"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg> Save ' + formatMoney(savedAmount) + '</span>';
    }

    return (
      '<div class="fbt-card-connector">+</div>' +
      '<div class="fbt-card" data-fbt-item data-price="' + price + '" data-compare-at="' + compareAt + '" data-variant-id="' + variant.id + '" data-product-handle="' + p.handle + '" data-quantity="1">' +
        '<div class="fbt-card__header-bar">' +
          '<label class="fbt-card__checkbox-label">' +
            '<input type="checkbox" class="fbt-card__checkbox">' +
            '<span class="fbt-card__check-indicator">✓</span>' +
          '</label>' +
          '<button type="button" class="fbt-card__view-btn" data-fbt-quickview aria-label="Quick view ' + escapeHtml(p.title) + '">' +
            '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>' +
              '<circle cx="12" cy="12" r="3"></circle>' +
            '</svg>' +
          '</button>' +
          saveTagHTML +
        '</div>' +
        '<div class="fbt-card__img-wrap">' +
          '<img src="' + imageUrl + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="140" height="140">' +
        '</div>' +
        '<a href="' + productUrl + '" target="_blank" rel="noopener" class="fbt-card__title" title="' + escapeHtml(p.title) + '">' +
          escapeHtml(p.title) +
        '</a>' +
        '<div class="fbt-card__pricing">' +
          compareHTML +
          '<span class="fbt-card__sale-price">' + formatMoney(price) + '</span>' +
        '</div>' +
        variantSelectHTML +
      '</div>'
    );
  }

  function normalizeProductEntry(p) {
    if (String(p.id) === String(productId)) return null;

    if (!p.featured_image && p.images && p.images.length > 0) {
      p.featured_image = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
    }

    if (p.variants) {
      p.variants.forEach(function (v) {
        if (typeof v.price === 'string') {
          v.price = Math.round(parseFloat(v.price) * 100);
        }
        if (v.compare_at_price && typeof v.compare_at_price === 'string') {
          v.compare_at_price = Math.round(parseFloat(v.compare_at_price) * 100);
        }
      });
    }

    const avail = (p.variants || []).find(function (v) { return v.available; });
    return avail ? { product: p, variant: avail } : null;
  }

  function sortEntriesByRelevance(entries) {
    if (!currentProductType) return entries;

    return entries
      .map(function (entry, index) { return { entry: entry, index: index }; })
      .sort(function (a, b) {
        const aType = (a.entry.product.product_type || a.entry.product.type || '').trim().toLowerCase();
        const bType = (b.entry.product.product_type || b.entry.product.type || '').trim().toLowerCase();
        const aMatch = aType === currentProductType ? 0 : 1;
        const bMatch = bType === currentProductType ? 0 : 1;

        if (aMatch !== bMatch) return aMatch - bMatch;
        return a.index - b.index;
      })
      .map(function (wrapped) { return wrapped.entry; });
  }

  function renderEntries(entries) {
    entries = sortEntriesByRelevance(entries);

    let html = '';
    entries.slice(0, MAX_RELATED_PRODUCTS).forEach(function (e) {
      html += buildCardHTML(e.product, e.variant);
    });

    cardsTrack.insertAdjacentHTML('beforeend', html);

    cardsTrack.querySelectorAll('.fbt-card:not(.fbt-card--main)').forEach(function (card) {
      attachCardListeners(card);
    });

    updateCarouselArrows();
    updateBundleState();
  }

  function getCollectionHandle() {
    let colHandle = wrapper.getAttribute('data-collection-handle');
    if (!colHandle || colHandle === 'all') {
      const match = window.location.pathname.match(/\/collections\/([^\/]+)/);
      colHandle = match ? match[1] : 'all';
    }
    return colHandle || 'all';
  }

  function fetchRecommendations() {
    const recsRequest = fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + MAX_RELATED_PRODUCTS + '&intent=related')
      .then(function (res) { return res.json(); })
      .catch(function () { return { products: [] }; });

    const collectionRequest = fetch('/collections/' + getCollectionHandle() + '/products.json?limit=' + (MAX_RELATED_PRODUCTS * 2))
      .then(function (res) { return res.json(); })
      .catch(function () { return { products: [] }; });

    Promise.all([recsRequest, collectionRequest]).then(function (results) {
      wrapper.querySelectorAll('[data-fbt-skeleton]').forEach(function (el) { el.remove(); });

      const seen = {};
      const entries = [];

      results.forEach(function (data) {
        (data.products || []).forEach(function (p) {
          if (seen[p.id]) return;
          seen[p.id] = true;
          const entry = normalizeProductEntry(p);
          if (entry) entries.push(entry);
        });
      });

      if (entries.length === 0) {
        updateCarouselArrows();
        return;
      }

      renderEntries(entries);
    });
  }

  fetchRecommendations();
  updateBundleState();
  initSearchPopup();

  // ═══════════════════════════════════════════════════════════════════
  // 6. Search Popup (replaces inline search)
  // ═══════════════════════════════════════════════════════════════════
  function initSearchPopup() {
    if (!searchModal || !searchInput || !searchResults) return;

    let debounceTimer = null;
    let searchToken = 0;

    function openSearchModal() {
      if (typeof searchModal.showModal === 'function') {
        searchModal.showModal();
      } else {
        searchModal.setAttribute('open', '');
      }
      // Focus input after modal opens
      setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 80);
    }

    function closeSearchModal() {
      if (typeof searchModal.close === 'function') {
        searchModal.close();
      } else {
        searchModal.removeAttribute('open');
      }
    }

    if (searchOpenBtn) {
      searchOpenBtn.addEventListener('click', openSearchModal);
    }

    if (searchCloseBtn) {
      searchCloseBtn.addEventListener('click', closeSearchModal);
    }

    // Close when clicking backdrop
    if (searchModal) {
      searchModal.addEventListener('click', function (e) {
        if (e.target === searchModal) {
          closeSearchModal();
        }
      });
    }

    function renderSearchResults(products) {
      if (!products.length) {
        searchResults.innerHTML = '<div class="fbt-search-empty">No matching products found.</div>';
        return;
      }

      let html = '';
      products.forEach(function (p) {
        const img = p.image || (p.featured_image && p.featured_image.url) || '';

        let priceCents = 0;
        if (p.price !== undefined && p.price !== null) {
          priceCents = Math.round(parseFloat(p.price) * 100);
        }

        const price = priceCents > 0 ? formatMoney(priceCents) : '';

        html +=
          '<div class="fbt-search-result-item" data-handle="' + p.handle + '">' +
            '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" class="fbt-search-result-img" loading="lazy">' +
            '<div class="fbt-search-result-info">' +
              '<span class="fbt-search-result-title">' + escapeHtml(p.title) + '</span>' +
              '<span class="fbt-search-result-price">' + price + '</span>' +
            '</div>' +
            '<button type="button" class="fbt-search-result-add" data-fbt-search-add>+ Add</button>' +
          '</div>';
      });

      searchResults.innerHTML = html;
    }

    searchInput.addEventListener('input', function () {
      const query = searchInput.value.trim();

      if (debounceTimer) clearTimeout(debounceTimer);

      if (query.length < 2) {
        searchResults.innerHTML = '<div class="fbt-search-loading">Start typing to search products...</div>';
        return;
      }

      searchResults.innerHTML = '<div class="fbt-search-loading">Searching…</div>';

      debounceTimer = setTimeout(function () {
        const thisToken = ++searchToken;

        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (thisToken !== searchToken) return;
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            const filtered = products.filter(function (p) { return String(p.id) !== String(productId); });
            renderSearchResults(filtered);
          })
          .catch(function (err) {
            console.error('FBT search error:', err);
            searchResults.innerHTML = '<div class="fbt-search-empty">Search failed. Please try again.</div>';
          });
      }, 300);
    });

    searchResults.addEventListener('click', function (e) {
      const addBtn = e.target.closest('[data-fbt-search-add]');
      if (!addBtn) return;

      const item = addBtn.closest('.fbt-search-result-item');
      const handle = item ? item.dataset.handle : null;
      if (!handle) return;

      const alreadyInBundle = cardsTrack.querySelector('.fbt-card[data-product-handle="' + handle + '"]');
      if (alreadyInBundle) {
        alreadyInBundle.scrollIntoView({ behavior: 'smooth', inline: 'center' });
        const cb = alreadyInBundle.querySelector('.fbt-card__checkbox');
        if (cb && !cb.checked && !cb.disabled) {
          cb.checked = true;
          alreadyInBundle.classList.add('is-selected');
          updateBundleState();
        }
        closeSearchModal();
        return;
      }

      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('Product fetch failed');
          return res.json();
        })
        .then(function (p) {
          const entry = normalizeProductEntry(p);
          if (!entry) {
            addBtn.disabled = false;
            addBtn.textContent = '+ Add';
            return;
          }

          cardsTrack.insertAdjacentHTML('beforeend', buildCardHTML(entry.product, entry.variant));

          const newCard = cardsTrack.lastElementChild;
          if (newCard) {
            attachCardListeners(newCard);
            const cb = newCard.querySelector('.fbt-card__checkbox');
            if (cb) {
              cb.checked = true;
              newCard.classList.add('is-selected');
            }
            newCard.scrollIntoView({ behavior: 'smooth', inline: 'center' });
          }

          updateCarouselArrows();
          updateBundleState();

          addBtn.textContent = '✓ Added';
          // Close modal after short delay so user sees the ✓
          setTimeout(function () {
            closeSearchModal();
            searchInput.value = '';
            searchResults.innerHTML = '<div class="fbt-search-loading">Start typing to search products...</div>';
          }, 400);
        })
        .catch(function (err) {
          console.error('FBT manual add error:', err);
          addBtn.disabled = false;
          addBtn.textContent = '+ Add';
        });
    });
  }

  // ═══════════════════════════════════════════════════════════════════
  // 7. Add to cart with FBT5 discount code
  // ═══════════════════════════════════════════════════════════════════
  if (addBundleBtn) {
    addBundleBtn.addEventListener('click', function () {
      const selectedCards = wrapper.querySelectorAll('.fbt-card.is-selected');
      const items = [];

      selectedCards.forEach(function (card) {
        const vid = parseInt(card.dataset.variantId, 10);
        const qty = parseInt(card.dataset.quantity || 1, 10);
        if (!isNaN(vid) && vid > 0 && qty > 0) {
          items.push({ id: vid, quantity: qty });
        }
      });

      if (items.length === 0) return;

      const hasOtherItems = wrapper.querySelectorAll('.fbt-card.is-selected:not(.fbt-card--locked)').length > 0;

      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      addBundleBtn.disabled = true;
      if (ctaSpinnerEl) ctaSpinnerEl.hidden = false;
      if (ctaTextEl) ctaTextEl.textContent = 'Adding Bundle to Cart...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              const msg = (data && (data.description || data.message)) || 'Could not add items';
              throw new Error(msg);
            }
            return data;
          });
        })
        .then(function () {
          if (hasOtherItems) {
            window.location.href = '/discount/' + FBT_DISCOUNT_CODE + '?redirect=/cart';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.error('FBT Add Bundle Error:', err);
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          }
          addBundleBtn.disabled = false;
          if (ctaSpinnerEl) ctaSpinnerEl.hidden = true;
          updateBundleState();
        });
    });
  }

  // 8. Main variant sync
  function syncMainWithTopPills() {
    const dataScript = document.getElementById('fbt-variants-data');
    if (!dataScript) return;

    let variants;
    try {
      variants = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    function updateMainVariant(variantId) {
      if (!variantId || !mainCard) return;
      const matched = variants.find(function (v) { return v.id === variantId; });
      if (!matched) return;

      mainCard.dataset.price = matched.price;
      mainCard.dataset.compareAt = matched.compare_at_price || matched.price;
      mainCard.dataset.variantId = matched.id;

      const salePriceEl = mainCard.querySelector('.fbt-card__sale-price');
      if (salePriceEl) salePriceEl.textContent = formatMoney(matched.price);

      const select = mainCard.querySelector('.fbt-main-select');
      if (select) select.value = matched.id;

      updateBundleState();
    }

    document.addEventListener('change', function (e) {
      const target = e.target;
      if (target.matches('input[type="radio"][data-variant-id]')) {
        updateMainVariant(parseInt(target.getAttribute('data-variant-id'), 10));
      } else if (target.matches('input[name="id"], select[name="id"]')) {
        updateMainVariant(parseInt(target.value, 10));
      }
    });

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        updateMainVariant(e.detail.variant.id);
      }
    });
  }

  syncMainWithTopPills();
});